import React from 'react'
import { graphql } from 'gatsby'

import Layout from '@/components/Layout'
import SEO from '@/components/Seo'

import HomeCategories from '@/components/HomeCategories'
import VideoPage from '@/components/VideoPage'

const PageTemplate = ({ data }) => {
  console.log('data in pageTemplate', data)
  const { googleSheetSheetJsRow } = data
  return (
    <Layout>
      <SEO title={googleSheetSheetJsRow.nombre} />
      <VideoPage data={googleSheetSheetJsRow} />
      <HomeCategories />
    </Layout>
  )
}

export default PageTemplate

export const query = graphql`
  query pageQuery($id: String!) {
    googleSheetSheetJsRow(id: { eq: $id }) {
      id
      curso
      nombre
      profesor
      rudoid
      videoid
      descripcion
      asignatura
      imagenFile {
        url
        childImageSharp {
          ancha: fluid(maxWidth: 1200, quality: 80) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
  }
`
